import { SVGProps } from 'react';
const Zcentral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 54.5 54.5"
    fill="none"
    {...props}
  >
    <g transform="translate(2.46 0)">
      <path
        fill="url(#g0)"
        d="M34.6799 0.0981426C34.6171 0.0659535 34.5577 0.0328064 34.4972 0.000127734C34.9612 0.000127734 8.33486 0 8.33486 0C3.73163 0 0 3.73178 0 8.33503C0 12.9383 3.73161 16.6699 8.33486 16.6699H26.4626C30.4389 13.5954 33.6949 11.0012 34.8713 9.87155C39.6464 5.28727 37.4818 1.53079 34.6799 0.0981426Z"
      />
    </g>
    <g transform="translate(14.36 37.83)">
      <path
        fill="url(#g1)"
        d="M31.4911 0H11.2203C7.24414 3.0744 3.98849 5.66851 2.81178 6.79817C-1.96359 11.3824 0.201295 15.1389 3.00289 16.5717C3.06595 16.6041 3.12556 16.6367 3.18583 16.6697H31.4911C36.0943 16.6697 39.8259 12.9377 39.8259 8.33486C39.8259 3.73197 36.0943 0 31.4911 0Z"
      />
    </g>
    <g transform="translate(0.31 0)">
      <path
        fill="url(#g2)"
        d="M12.222 54.4999H18.3818C18.3215 54.4668 18.2619 54.4342 18.1989 54.4019C15.3973 52.969 13.2324 49.2126 18.0078 44.6283C21.9163 40.8761 48.7604 20.966 48.7604 20.966C51.8639 18.6262 53.8746 15.185 53.8746 11.2495C53.8746 4.49968 49.5677 0 41.6529 0H35.493C35.5535 0.0326787 35.6129 0.0658258 35.6757 0.0980148C38.4776 1.53066 40.6421 5.28712 35.8671 9.8714C31.9591 13.6233 5.11478 33.5337 5.11478 33.5337C2.01052 35.8737 0 39.3145 0 43.25C0 49.9998 4.30725 54.4999 12.222 54.4999Z"
      />
    </g>
    <defs>
      <linearGradient
        id="g0"
        x1={7.48868}
        x2={60.7845}
        y1={-2.6784}
        y2={44.137}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#24C79A" />
        <stop offset={0.4729} stopColor="#0058D6" />
        <stop offset={1} stopColor="#7700A7" />
      </linearGradient>
      <linearGradient
        id="g1"
        x1={-25.4375}
        x2={32.6455}
        y1={-16.966}
        y2={16.5254}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.5011} stopColor="#003D94" />
        <stop offset={0.9665} stopColor="#7F57D1" />
      </linearGradient>
      <linearGradient
        id="g2"
        x1={70.2802}
        x2={-47.1474}
        y1={-7.11657}
        y2={85.9918}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#14E0FF" />
        <stop offset={0.5} stopColor="#2C6BFF" />
        <stop offset={1} stopColor="#7700A7" />
      </linearGradient>
    </defs>
  </svg>
);
export default Zcentral;
